<div
    *ngIf="shown"
    class="toggle flex flex-row items-start"
    [class.toggle--message]="type === 'message'"
    [class.toggle--error]="type === 'error'"
    [class.toggle--notification]="type === 'notification'"
    [class.toggle--warning]="type === 'warning'"
    [class.toggle--rounded]="toggleStyle === 'rounded'"
    [class.toggle--light]="theme === 'light'"
    [class.toggle--dark]="theme === 'dark'"
    @show>

    <div *ngIf="icon" class="mr-3">
        <div class="toggle__icon">
            <app-icon [icon]="icon"></app-icon>
        </div>
    </div>

    <div class="toggle__content">
        <ng-content></ng-content>
    </div>
 
    <button class="toggle__icon toggle__dismiss" (click)="handleDismissClicked()">
        <app-icon icon="times">
        </app-icon>
    </button>

</div>